// extracted by mini-css-extract-plugin
export default {"cls1":"fBOG3mN0bIhM7xM0Trea","cls2":"PqXb_CbvBBMDJ12UftMP fBOG3mN0bIhM7xM0Trea"};